import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { PlusIcon, Trash2Icon } from 'lucide-react';
import { websiteLanguagesOptions } from '../../data/intakeOptions';
import { toOptions } from '../../utils/options';
export function Step4Company() {
  const {
    data,
    updateData
  } = useIntake();
  const addLocation = () => {
    const newLocation = {
      id: Date.now().toString(),
      name: '',
      street: '',
      postcode: '',
      city: '',
      province: '',
      country: 'Nederland',
      phone: '',
      email: '',
      hours: '',
      showOnWebsite: 'yes',
      needsPage: false,
      services: ''
    };
    updateData({
      locations: [...data.locations, newLocation]
    });
  };
  const removeLocation = (id: string) => {
    updateData({
      locations: data.locations.filter(l => l.id !== id)
    });
  };
  const updateLocation = (id: string, field: string, value: any) => {
    updateData({
      locations: data.locations.map(l => l.id === id ? {
        ...l,
        [field]: value
      } : l)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-404" data-mp="1r6jbteagjak3">
      <MascotPanel message="Tijd voor de officiële gegevens. Deze informatie gebruiken we voor de contactpagina, footer en eventuele juridische documenten op uw nieuwe website." data-id="element-405" data-mp="1h72a17ybtgte" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-406" data-mp="5uj8nluht1jk">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-407" data-mp="u3zl6h8ug7e">
          Bedrijfsgegevens
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-408" data-mp="2p02ju9g762wn">
          <Input label="Bedrijfsnaam (Statutair)" value={data.companyName} onChange={e => updateData({
          companyName: e.target.value
        })} data-id="element-409" data-mp="2t1xg2zj9tq3k" />
          <Input label="Handelsnaam (indien anders)" value={data.tradeName} onChange={e => updateData({
          tradeName: e.target.value
        })} data-id="element-410" data-mp="2jzy10crtgw39" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-411" data-mp="1wbn2vhdi9aio">
          <Input label="KVK Nummer" value={data.cocNumber} onChange={e => updateData({
          cocNumber: e.target.value
        })} data-id="element-412" data-mp="1wdhoyz0ij8oc" />
          <Input label="BTW Nummer" value={data.vatNumber} onChange={e => updateData({
          vatNumber: e.target.value
        })} data-id="element-413" data-mp="1rck9wvasuur2" />
        </div>

        <div className="mb-6" data-id="element-414" data-mp="13q8a6azk1ht7">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-415" data-mp="13qzyr1uqif9z">
            Hoofdvestiging adres
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-416" data-mp="1hmlh4q6gq0tf">
            Vul uw straat en huisnummer in — de overige velden worden waar
            mogelijk automatisch aangevuld.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-417" data-mp="1qntbix5uyhi8">
            <Input label="Straat + Huisnummer" placeholder="Bijv. Keizersgracht 123" value={data.mainStreet} onChange={e => updateData({
            mainStreet: e.target.value
          })} data-id="element-418" data-mp="1mn9hw3khtw0u" />
            <Input label="Postcode" placeholder="1234 AB" value={data.mainPostcode} onChange={e => updateData({
            mainPostcode: e.target.value
          })} data-id="element-419" data-mp="2aeeu88r8666e" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-420" data-mp="7pncbrtcfpkr">
            <Input label="Stad" placeholder="Amsterdam" value={data.mainCity} onChange={e => updateData({
            mainCity: e.target.value
          })} data-id="element-421" data-mp="ch553sl7qjun" />
            <Input label="Provincie" placeholder="Noord-Holland" value={data.mainProvince} onChange={e => updateData({
            mainProvince: e.target.value
          })} data-id="element-422" data-mp="3g0rkqt209a0m" />
            <Input label="Land" value={data.mainCountry} onChange={e => updateData({
            mainCountry: e.target.value
          })} data-id="element-423" data-mp="3utbc6wfslt28" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-424" data-mp="2umy4ti6m2gaw">
          <Input label="Algemeen telefoonnummer" value={data.companyPhone} onChange={e => updateData({
          companyPhone: e.target.value
        })} data-id="element-425" data-mp="2po4pdk7rkf83" />
          <Input label="Algemeen e-mailadres" type="email" value={data.companyEmail} onChange={e => updateData({
          companyEmail: e.target.value
        })} data-id="element-426" data-mp="2fybgws2x4g82" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-427" data-mp="21zlkzfru4mla">
          <Input label="Huidige website URL (indien van toepassing)" placeholder="https://www.uwbedrijf.nl" value={data.existingWebsiteUrl} onChange={e => updateData({
          existingWebsiteUrl: e.target.value
        })} data-id="element-428" data-mp="1x08zozgm3nkt" />
          <Input label="In welke branche bent u actief?" placeholder="Bijv. Installatietechniek, Accountancy, Horeca" value={data.industry} onChange={e => updateData({
          industry: e.target.value
        })} data-id="element-429" data-mp="1pnswum8wnmpu" />
        </div>

        <div className="mb-8" data-id="element-430" data-mp="1kndfzkpezx34">
          <Textarea label="Social media kanalen (links)" placeholder="Bijv. instagram.com/uwbedrijf, linkedin.com/company/uwbedrijf" value={data.socialLinks} onChange={e => updateData({
          socialLinks: e.target.value
        })} data-id="element-431" data-mp="28eizc9ukd7i6" />
        </div>

        <div className="mb-8" data-id="element-432" data-mp="23e4qipl51tj3">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-433" data-mp="n1ppfgfn48zi">
            In welke talen moet de website beschikbaar zijn?
          </label>
          <RadioGroup columns={3} value={data.websiteLanguages} onChange={val => updateData({
          websiteLanguages: val
        })} options={toOptions(websiteLanguagesOptions)} data-id="element-434" data-mp="s2dlwhmn1i14" />
          <AnimatePresence data-id="element-435" data-mp="3f7yn2h4ptodn">
            {data.websiteLanguages === 'more' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden" data-id="element-436" data-mp="3b7ervj3pcuu5">
                <div className="pt-4" data-id="element-437" data-mp="2igwd3ktm950w">
                  <Input placeholder="Welke talen? Bijv. Nederlands, Engels, Duits" value={data.websiteLanguagesOther} onChange={e => updateData({
                websiteLanguagesOther: e.target.value
              })} data-id="element-438" data-mp="2waxfcojs1a60" />
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        <div className="pt-8 border-t border-gray-100" data-id="element-439" data-mp="2opdb1xpxinc4">
          <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-440" data-mp="2tneske7pielh">Locaties</h3>

          <div className="mb-6" data-id="element-441" data-mp="2xngveqp6he2c">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-442" data-mp="2xn75120814w4">
              Heeft u meerdere locaties?
            </label>
            <RadioGroup columns={2} value={data.multipleLocations} onChange={val => updateData({
            multipleLocations: val
          })} options={[{
            value: 'yes',
            label: 'Ja, meerdere locaties'
          }, {
            value: 'no',
            label: 'Nee, één locatie'
          }]} data-id="element-443" data-mp="32kp5e406absi" />
          </div>

          <AnimatePresence data-id="element-444" data-mp="3vaxqo4q09cbb">
            {data.multipleLocations === 'yes' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden space-y-6" data-id="element-445" data-mp="99zz9e6rdge8">
                <div data-id="element-446" data-mp="s10ym3bsjdyb">
                  <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-447" data-mp="rzg6slgv2945">
                    Hoe wilt u de locaties op de website verwerken?
                  </label>
                  <RadioGroup columns={1} value={data.locationStrategy} onChange={val => updateData({
                locationStrategy: val
              })} options={[{
                value: 'separate_website',
                label: 'Een aparte website per locatie'
              }, {
                value: 'separate_page',
                label: 'Een aparte pagina per locatie op dezelfde website'
              }, {
                value: 'mention_only',
                label: 'Eén website met alleen benoeming van de locaties (bijv. in de footer)'
              }, {
                value: 'no_mention',
                label: 'Geen benoeming van specifieke locaties'
              }, {
                value: 'specific_only',
                label: 'Alleen specifieke locaties benoemen, andere niet'
              }]} data-id="element-448" data-mp="ia6bkwqq0abt" />
                </div>

                <div className="bg-blue-50 p-4 rounded-xl border border-blue-100" data-id="element-449" data-mp="32hh10ufpaltr">
                  <p className="text-sm text-blue-800" data-id="element-450" data-mp="3m651jzi7zjtx">
                    <strong data-id="element-451" data-mp="3r4zrdlelu8nj">Tip voor gebruikersgemak:</strong> Voeg uw locaties
                    hieronder toe. Wij denken graag met u mee over een handige
                    zoekfunctie of interactieve kaart voor uw bezoekers.
                  </p>
                </div>

                <div className="space-y-6" data-id="element-452" data-mp="33evqvmwpqp0r">
                  <h4 className="font-bold text-gray-900" data-id="element-453" data-mp="33ducp9kehmet">
                    Locaties toevoegen
                  </h4>

                  {data.locations.map((loc, index) => <motion.div key={loc.id} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="p-6 bg-gray-50 rounded-2xl border border-gray-200 relative space-y-4" data-id="element-454" data-mp="2thhatoepc28z" data-mpi={index}>
                      <button onClick={() => removeLocation(loc.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-455" data-mp="v073ep9lvzbn">
                        <Trash2Icon className="w-5 h-5" data-id="element-456" data-mp="gargjkd74e18" />
                      </button>

                      <h5 className="font-semibold text-gray-900" data-id="element-457" data-mp="1dy9x3hd3mkfs">
                        Locatie {index + 1}
                      </h5>

                      <Input label="Naam locatie (bijv. Vestiging Amsterdam)" value={loc.name} onChange={e => updateLocation(loc.id, 'name', e.target.value)} data-id="element-458" data-mp="18z6r9upaoa6r" />

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-459" data-mp="3or4gxlgqmnyy">
                        <Input label="Straat + Huisnummer" value={loc.street} onChange={e => updateLocation(loc.id, 'street', e.target.value)} data-id="element-460" data-mp="3kneup2njcih3" />
                        <Input label="Postcode" value={loc.postcode} onChange={e => updateLocation(loc.id, 'postcode', e.target.value)} data-id="element-461" data-mp="29627d52brtmw" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-462" data-mp="2nxuit5z00njc">
                        <Input label="Stad" value={loc.city} onChange={e => updateLocation(loc.id, 'city', e.target.value)} data-id="element-463" data-mp="2rxuwupi6qwpv" />
                        <Input label="Provincie" value={loc.province} onChange={e => updateLocation(loc.id, 'province', e.target.value)} data-id="element-464" data-mp="12j6mett5nouh" />
                        <Input label="Land" value={loc.country} onChange={e => updateLocation(loc.id, 'country', e.target.value)} data-id="element-465" data-mp="h53e8gsj4vpk" />
                      </div>

                      {data.locationStrategy === 'specific_only' && <div className="pt-2" data-id="element-466" data-mp="3udzqnaf41spz">
                          <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-467" data-mp="3uerc3sezua2j">
                            Deze locatie tonen op de website?
                          </label>
                          <RadioGroup columns={2} value={loc.showOnWebsite} onChange={val => updateLocation(loc.id, 'showOnWebsite', val)} options={[{
                    value: 'yes',
                    label: 'Ja, tonen'
                  }, {
                    value: 'no',
                    label: 'Nee, verbergen'
                  }]} data-id="element-468" data-mp="31uizyxcw5u8c" />
                        </div>}
                    </motion.div>)}

                  <Button variant="outline" onClick={addLocation} className="w-full border-dashed" data-id="element-469" data-mp="1m7nw8151y856">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-470" data-mp="as8xosx7387y" />
                    Locatie toevoegen
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}